<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<span epub:type="pagebreak" id="pg_v" title="v">
<p class="TIT" id="tit"><img alt="" height="800" src="images/title.jpg" width="530"/></p>
</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1bc2317e